import type { FreeCropCorner } from '../types/freeCrop';

const getPointSumsAndDiffs = (point: FreeCropCorner) => {
  return { sum: point.x + point.y, diff: point.x - point.y };
};

export const orderQuadCorners = (corners: FreeCropCorner[]): FreeCropCorner[] | null => {
  if (corners.length !== 4) {
    return null;
  }

  const points = [...corners];

  const withMetrics = points.map((point) => ({ point, ...getPointSumsAndDiffs(point) }));

  const topLeft = withMetrics.reduce((best, current) => (current.sum < best.sum ? current : best)).point;
  const bottomRight = withMetrics.reduce((best, current) => (current.sum > best.sum ? current : best)).point;
  const topRight = withMetrics.reduce((best, current) => (current.diff > best.diff ? current : best)).point;
  const bottomLeft = withMetrics.reduce((best, current) => (current.diff < best.diff ? current : best)).point;

  return [topLeft, topRight, bottomRight, bottomLeft];
};

